export const COLOR_PRIMARY = "#2335d4";
export const COLOR_SECONDARY = "#00e676";
export const COLOR_ATHENS_GRAY = "#FAFBFC";
export const COLOR_ATHENS_GRAY_DARKER = "#F4F5F7";
export const COLOR_ATHENS_GRAY_DARKER_2 = "#EBECF0";
export const COLOR_TUNA = "#3A3A3C";
export const COLOR_DOWNRIVER = "#091E42";
export const COLOR_DODGER_BLUE = "#2684FF";
export const COLOR_WHITE = "#ffffff";
export const COLOR_BLACK = "#000000";
export const COLOR_SCIENCE_BLUE = "#0052CC";
export const COLOR_FIORD = "#42526E";
export const COLOR_WELL_READ = "#B12F39";
export const COLOR_PACIFIC_BLUE = "#00A3BF";
export const COLOR_STALE_GRAY = "#6B778C";
export const COLOR_OCEAN_GREEN = "#36B37E";
export const COLOR_NILE_BLUE = "#172B4D";
export const COLOR_FUCHSIA_BLUE = "#6554C0";
export const COLOR_NIAGARA = "#08A588";
export const COLOR_PATTERNS_BLUE = "#DEEBFF";
export const COLOR_TREE_POPPY = "#FF991F";
export const COLOR_SHUTTLE_GRAY = "#5E6C84";
export const COLOR_BLUE_BAYOUX = "#4F5F79";
export const COLOR_PICKLE_BLUEWOOD = "#344563";
export const COLOR_MISCHKA = "#DFE1E6";
export const COLOR_MILANO_RED = "#BF2600";
export const COLOR_GRAY_CHATEAU = "#97A0AF";
export const COLOR_ALTO = "#DADADA";
export const COLOR_SHAMROCK = "#31C48D";
export const COLOR_BLUE_RIBBON = "#0065FF";
export const COLOR_LINK_WATER = "#d3dff2";
export const COLOR_ZUMTHOR = "#E5F0FF";
export const COLOR_HAWKES_BLUE = "#e1ecfc";
export const COLOR_SOLITUDE = "#e0eafe";
export const COLOR_COOL_GREY = "#8993a4";
export const COLOR_LIGHT_SLATE_GRAY = "#7A869A";
export const COLOR_IRON = "#dfe1e5";
export const COLOR_TRUE_V = "#8676D9";
export const COLOR_SUPERNOVA = "#fec403";
export const COLOR_PERSIMMON = "#fe7552";

export const TABLE_OPTIONS_WIDTH_MULTIPLIER = 21;
export const TABLE_NUMBER_WIDTH_MULTIPLIER = 4;
export const TABLE_ROW_HEIGHT = 48;

export const TABLE_PAGINATION_ROWS_PER_PAGE_OPTIONS = [10, 30, 50, 100];

export const NETWORK_INPUT_WIDTH = 280;


export const MATCHING_GROUND_ACTIVE_BG = "#FFF0B3";
export const MATCHING_GROUND_ACTIVE_TEXT = "#FF8B00";
export const MATCHING_GROUND_MATCHING_BG = "#ABF5D1";
export const MATCHING_GROUND_MATCHING_TEXT = "#006644";
export const MATCHING_GROUND_UPCOMING_BG = "#B3D4FF";
export const MATCHING_GROUND_UPCOMING_TEXT = "#0747A6";
export const MATCHING_GROUND_CLOSED_BG = "#FFBDAD";
export const MATCHING_GROUND_CLOSED_TEXT = "#BF2600";
export const MATCHING_GROUND_ARCHIVED_BG = "#DFE1E6";
export const MATCHING_GROUND_ARCHIVED_TEXT = "#42526E";


